import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { NavItem } from '../NavItem'
import FulfillmentTestingCenterLogo from '../../../../../assets/ftc-logo.svg'
import WebhookConfigurationLogo from '../../../../../assets/webhook-configuration-logo.svg'
import clientEnv from '../../../../../utils/global/clientEnv'
import { usePartnerId } from '../../../../../utils/routing/params.hooks'
import { type DashRouteSet, DASH_ROUTE_URLS } from '../../../../../utils/routing/routes'
import { Permission } from '../../../../../legacy/common/types'
import { FeatureToggle } from '../../../../../legacy/contexts/featureToggles/FeatureToggleContext'
import { type AccessControlConfig } from '../../../../../legacy/components/AccessControl/accessControl.utils'

const logoStyle = css({
  width: '36px',
})

const WebhookConfigurationSectionAccessControl: AccessControlConfig = {
  permissions: Permission.DevPortalAdmin,
  featureToggles: [FeatureToggle.WebhookConfiguration],
}

const FTCNavItem = props => (
  <NavItem
    isMainItem
    Icon={() => <img src={FulfillmentTestingCenterLogo} css={logoStyle} />}
    title="app.devPortal.nav.links.ftc"
    {...props}
  />
)

const WebhooksNavItem = props => (
  <NavItem
    isMainItem
    Icon={() => <img src={WebhookConfigurationLogo} css={logoStyle} />}
    title="app.devPortal.nav.links.webhookConfiguration"
    accessControl={WebhookConfigurationSectionAccessControl}
    {...props}
  />
)

export const DevPortalNavMainContent: FunctionComponent = () => {
  const partnerId = usePartnerId()
  return (
    <React.Fragment>
      {clientEnv.PUBLIC_CLIENT_ENVIRONMENT == 'enterprise-dev' ? (
        <WebhooksNavItem
          href={buildHref(
            partnerId,
            clientEnv.PUBLIC_CLIENT_PRODUCTION_URL,
            'app-dev-portal-webhook-configuration'
          )}
          rel="noopener noreferrer"
        />
      ) : (
        <WebhooksNavItem route="app-dev-portal-webhook-configuration" />
      )}
      {clientEnv.PUBLIC_CLIENT_ENVIRONMENT == 'production' ? (
        <FTCNavItem
          href={buildHref(
            partnerId,
            clientEnv.PUBLIC_CLIENT_RPP_DEV_URL,
            'app-dev-portal-fulfillment-testing-center'
          )}
          rel="noopener noreferrer"
        />
      ) : (
        <FTCNavItem route="app-dev-portal-fulfillment-testing-center" />
      )}
    </React.Fragment>
  )
}

function buildHref(partnerId: string, host: string, pathId: DashRouteSet['identifier']): string {
  const path = DASH_ROUTE_URLS[pathId].replace(':partner_id', partnerId)
  return `${host}${path}`
}
